export var monthFullNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
export var getFullMonthName = function getFullMonthName(month) {
  return monthFullNames[month];
};
export var formatDate = function formatDate(date) {
  var formattedDate = new Date(date);
  var month = getFullMonthName(formattedDate.getMonth());
  var day = formattedDate.getDate();
  var year = formattedDate.getFullYear();
  return "".concat(month, " ").concat(day, ", ").concat(year);
};